import { render } from "./SeventhCut.vue?vue&type=template&id=da000c3a&scoped=true"
import script from "./SeventhCut.vue?vue&type=script&lang=js"
export * from "./SeventhCut.vue?vue&type=script&lang=js"

import "./SeventhCut.vue?vue&type=style&index=0&id=da000c3a&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da000c3a"]])

export default __exports__